// extracted by mini-css-extract-plugin
export var breadcrumb = "breadcrumb-module--breadcrumb--2WaYl";
export var breadcrumb__item = "breadcrumb-module--breadcrumb__item--1v_RT";
export var Current = "breadcrumb-module----current--1c4FL";
export var __current = "breadcrumb-module--__current--t5POf";